module.exports = "/assets/data/785a0ea7a15c0dba6771b0c99b2cbafb-L1.data.json";